import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }

import Footer from "../components/Footer.vue";
import { useGlobalStore } from "@/stores/GlobalStore";
import OurInformation from "@/components/contact/OurInformation.vue";
import SendMessage from "@/components/contact/SendMessageForm.vue";

// Access the global store

export default /*@__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {

const globalStore = useGlobalStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([_unref(globalStore).theme, "py-5"]),
      key: "contact"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-center mb-4" }, "Contact Us", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(OurInformation),
          _createVNode(SendMessage)
        ])
      ])
    ], 2),
    _createVNode(Footer)
  ], 64))
}
}

})